export default __webpack_public_path__ + "static/media/main.c5d26901.jpg";